import { withTranslations } from '@/utils/Language';
import resourceMapEn from '@/assets/i18n/resourceMap/en.json';

const enDefault = { ...resourceMapEn };

export default withTranslations(
  (lang) => Promise.all([import(`@/assets/i18n/resourceMap/${lang}.json`)]).then(([resourceMap]) => ({ ...resourceMap.default })),
  enDefault
);
